export default {
  init() {
    $('.archive-ordering').change(function (e) {
      $(this).closest('form').trigger('submit');
    })

    $('.woocommerce-product-gallery__image').click(function () {
      $('.woocommerce-product-gallery__trigger').trigger('click');
    })

    // jQuery('body.single-product .return-to-shop .button, header .menu-item a').click(function (e) {
    //   e.preventDefault();
    //   let button_url = $(this).attr('href');

    //   var data = {
    //     'action': 'reset_rental_cookie', // the name of your PHP function!
    //     'function': 'reset',    // a random value we'd like to pass
    //   };

    //   // jQuery.post(ajaxurl, data, function (response) {
    //   //   location.href = button_url;
    //   // });
    // })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js